import React, { FC, useCallback } from 'react'
import styled from 'styled-components'
import { VideoProps } from 'ui/video/types'

export const NativeVideo: FC<VideoProps> = ({ link, onApiReady }) => {
  const onElementReady = useCallback(
    (element: HTMLVideoElement) => {
      if (element) {
        const api = {
          play: () => {
            element.play()
          },
          pause: () => element.pause(),
          stop: () => {
            element.currentTime = 0
            element.pause()
          }
        }

        if (onApiReady) onApiReady(api)
      }
    },
    [onApiReady]
  )

  return (
    <Video controls ref={onElementReady}>
      <source src={`${link}#t=0.001`} />
    </Video>
  )
}

const Video = styled.video`
  width: 100%;
  outline: none;
`
